import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5445_18770)">
      <path
        d="M12.2499 7.71095C14.6168 7.71095 16.5357 9.63141 16.5357 12C16.5357 14.3687 14.6168 16.2892 12.2499 16.2892C9.88321 16.2892 7.96428 14.3687 7.96428 12C7.96428 9.63141 9.88321 7.71095 12.2499 7.71095ZM12.2499 -0.00939941C10.6332 -0.00939941 9.06142 0.309069 7.57643 0.93742C6.14607 1.54218 4.86357 2.4075 3.76429 3.50765C2.66499 4.6078 1.80035 5.8913 1.19607 7.32279C0.568214 8.80793 0.25 10.382 0.25 12C0.25 13.6181 0.568214 15.1911 1.19607 16.6773C1.80035 18.1087 2.66499 19.3923 3.76429 20.4924C4.86357 21.5926 6.14607 22.4579 7.57643 23.0626C9.06035 23.691 10.6332 24.0094 12.2499 24.0094C13.8667 24.0094 15.4386 23.691 16.9235 23.0626C18.3539 22.4579 19.6364 21.5926 20.7357 20.4924C21.835 19.3923 22.6997 18.1087 23.3039 16.6773C23.9318 15.1922 24.25 13.6181 24.25 12C24.25 10.382 23.9318 8.80894 23.3039 7.32279C22.6997 5.8913 21.835 4.6078 20.7357 3.50765C19.6364 2.4075 18.3539 1.54218 16.9235 0.93742C15.4397 0.309069 13.8667 -0.00939941 12.2499 -0.00939941Z"
        fill="#C1C8CD"
      />
      <path
        d="M12.2501 7.71098C14.6169 7.71098 16.5358 9.63144 16.5358 12.0001C16.5358 14.3687 14.6169 16.2892 12.2501 16.2892C9.88332 16.2892 7.96439 14.3687 7.96439 12.0001C7.96439 9.63144 9.88332 7.71098 12.2501 7.71098ZM12.2501 2.56409C7.05152 2.56409 2.82153 6.79741 2.82153 12.0001C2.82153 17.2027 7.05152 21.436 12.2501 21.436C17.4486 21.436 21.6787 17.2027 21.6787 12.0001C21.6787 6.79741 17.4486 2.56409 12.2501 2.56409Z"
        fill="#889096"
      />
      <path
        d="M12.2499 7.71101C14.6167 7.71101 16.5357 9.63144 16.5357 12.0001C16.5357 14.3687 14.6167 16.2892 12.2499 16.2892C9.88318 16.2892 7.96425 14.3687 7.96425 12.0001C7.96425 9.63144 9.88318 7.71101 12.2499 7.71101ZM12.2499 5.13757C8.46889 5.13757 5.39282 8.21605 5.39282 12.0001C5.39282 15.7842 8.46889 18.8626 12.2499 18.8626C16.0311 18.8626 19.1071 15.7842 19.1071 12.0001C19.1071 8.21605 16.0311 5.13757 12.2499 5.13757Z"
        fill="#687076"
      />
      <path
        d="M12.25 7.71094C14.6169 7.71094 16.5358 9.63135 16.5358 12C16.5358 14.3687 14.6169 16.2891 12.25 16.2891C9.88329 16.2891 7.96436 14.3687 7.96436 12C7.96436 9.63135 9.88329 7.71094 12.25 7.71094Z"
        fill="#C1C8CD"
      />
    </g>
    <defs>
      <clipPath id="clip0_5445_18770">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
)
